import React from "react";
import { Box, Button, Grid, Paper, Rating, Typography } from "@mui/material";
import { ArrowForwardIos } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

const CandidateServiceCard = ({service}) => {
    const navigate = useNavigate();
    return (
        <>
            {
                service != undefined
                ?
                <Paper>
                <Box sx={{ p: 2 }}>
                    <Grid container spacing={1}>
                        <Grid item md={8}>
                            <Typography py={1} className="subHeading2Bold">
                                {service?.serviceName}
                            </Typography>
                            <Rating py={1} defaultValue={4.5} precision={0.5} readOnly className="text1Mid"/> (0)
                            <Typography className="text1Mid" py={1}>
                                <div dangerouslySetInnerHTML={{ __html: service?.descriptionByCoach}}></div>
                            </Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Button onClick={() => navigate(`/candidate/featured-service/${service._id}`)} variant="outlined" sx={{ color: '#2544EE', borderColor: '#2544EE', borderRadius: '11px' }}>
                                View detail <ArrowForwardIos sx={{ fontSize: '0.85rem' }} />
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
                :
                <Paper>
                <Box sx={{ p: 2 }}>
                    <Grid container spacing={1}>
                        <Grid item md={8}>
                            <Typography py={1} className="subHeading2Bold">
                                Lorem Ipsum
                            </Typography>
                            <Rating py={1} defaultValue={4.5} precision={0.5} readOnly className="text1Mid"/> (0)
                            <Typography className="text1Mid" py={1}>
                                Lorem ipsum dolor sit amet consectetur.
                            </Typography>
                        </Grid>
                        <Grid item md={4}>
                            <Button variant="outlined" sx={{ color: '#2544EE', borderColor: '#2544EE', borderRadius: '11px' }}>
                                View detail <ArrowForwardIos sx={{ fontSize: '0.85rem' }} />
                            </Button>
                        </Grid>
                    </Grid>
                </Box>
            </Paper>
            }
        </>
    )
}

export default CandidateServiceCard;